import axios from "axios";

//IMPORT API ROUTE URL
import { GET_CLIENTS_BY_FIRM } from "./apiRoutes";

const getClientsByFirm = (user_slug, firm_id) => {
  var postData = new FormData();

  postData.append("user_slug", user_slug);
  postData.append("firm_id", firm_id);

  return axios
    .post(GET_CLIENTS_BY_FIRM, postData, {
      headers: {
        "Content-Type": "application/json",
      },
    })
    .then(function (response) {
      return response;
    })
    .catch(function (error) {
      return false;
    });
};

export default getClientsByFirm;
